import { CustomerAddress } from '@lambda/apis/src/customer/types';
import settings from '@/settings';
import { FieldNames, FormSchema } from './types';

export const formSchema: FormSchema = {
  'reebelo-us': {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'City',
      placeholder: 'New York',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    postalCode: {
      label: 'Zip Code',
      placeholder: '10001',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '123-456-7890',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
  'reebelo-ca': {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'City',
      placeholder: 'Toronto',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    state: {
      label: 'Province',
      placeholder: 'Select a province',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    postalCode: {
      label: 'Postal Code',
      placeholder: 'A1B 2C3',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '(506) 234-5678',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
  'reebelo-au': {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'Surburb or City',
      placeholder: 'Surburb or City',
      disabled: false,
      initialValue: '',
      required: true,
      hidden: false,
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      disabled: false,
      initialValue: '',
      required: true,
      hidden: false,
    },
    postalCode: {
      label: 'Postal Code',
      placeholder: '2000',
      disabled: false,
      initialValue: '',
      required: true,
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '0412 345 678',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
  quista: {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'City',
      placeholder: 'Singapore',
      disabled: true,
      required: true,
      initialValue: settings.country,
      hidden: false,
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: true,
    },
    postalCode: {
      label: 'Postal Code',
      placeholder: '123456',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '8123 4567',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
  'reebelo-nz': {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'City',
      placeholder: 'Auckland',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: true,
    },
    postalCode: {
      label: 'Postal Code',
      placeholder: '1010',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '021 123 4567',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
  'reebelo-dev': {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'City',
      placeholder: 'San Francisco',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: true,
    },
    postalCode: {
      label: 'Zip Code',
      placeholder: '94103',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '123-456-7890',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
  'reebelo-uk': {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Doe',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address1: {
      label: 'Address Line 1',
      placeholder: '123 Main St',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Apt, Suite, Building (optional)',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: false,
    },
    city: {
      label: 'City',
      placeholder: 'London',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    state: {
      label: 'State',
      placeholder: 'Select a state',
      disabled: false,
      required: false,
      initialValue: '',
      hidden: true,
    },
    postalCode: {
      label: 'Postal Code',
      placeholder: '10001',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
    phone: {
      label: 'Phone Number',
      placeholder: '+44 20 7123 4567',
      disabled: false,
      required: true,
      initialValue: '',
      hidden: false,
    },
  },
};

export const INITIAL_ADDRESS: CustomerAddress = {
  firstName:
    formSchema?.[settings.store]?.[FieldNames.FIRST_NAME].initialValue ?? '',
  lastName:
    formSchema?.[settings.store]?.[FieldNames.LAST_NAME].initialValue ?? '',
  address1:
    formSchema?.[settings.store]?.[FieldNames.ADDRESS1].initialValue ?? '',
  address2:
    formSchema?.[settings.store]?.[FieldNames.ADDRESS2].initialValue ?? '',
  city: formSchema?.[settings.store]?.[FieldNames.CITY].initialValue ?? '',
  state: formSchema?.[settings.store]?.[FieldNames.STATE].initialValue ?? '',
  postalCode:
    formSchema?.[settings.store]?.[FieldNames.POSTAL_CODE].initialValue ?? '',
  country: settings.country_code,
  phone: formSchema?.[settings.store]?.[FieldNames.PHONE].initialValue ?? '',
};
